@if (showArrowUI()) {
  <div class="tw-w-full tw-flex tw-justify-center tw-items-center">
    <svg xmlns="http://www.w3.org/2000/svg" class="tw-w-5" viewBox="0 0 640 640">
      <path fill="rgb(0, 0, 0)" d="M297.4 566.6C309.9 579.1 330.2 579.1 342.7 566.6L502.7 406.6C515.2 394.1 515.2 373.8 502.7 361.3C490.2 348.8 469.9 348.8 457.4 361.3L352 466.7L352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 466.7L182.6 361.3C170.1 348.8 149.8 348.8 137.3 361.3C124.8 373.8 124.8 394.1 137.3 406.6L297.3 566.6z"/>
    </svg>
  </div>
  <div class="tw-w-full tw-flex tw-px-4 tw-pt-4 tw-gap-2 tw-justify-start tw-items-center tw-mb-4">
    <img [src]="allocatedDoctorImage()" class="tw-w-12 tw-rounded-full" alt="Doctor" />
    <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-font-lexend">
      <h1 class="tw-text-600 tw-font-extrabold" i18n="@@howWillSolveIt">How we'll solve it?</h1>
    </div>
  </div>
}
<div class="tw-w-full tw-bg-white tw-mb-4 tw-shadow-z1">
  @if (!showArrowUI()) {
    <div class="tw-w-full tw-flex tw-px-4 tw-pt-4 tw-gap-2 tw-justify-start tw-items-center tw-mb-4">
      <img [src]="allocatedDoctorImage()" class="tw-w-12" alt="Doctor" />
      <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-font-lexend">
        <h1 class="tw-text-300 tw-font-extrabold" i18n="@@whatWeWillDoNext">WHAT WE'LL DO NEXT?</h1>
        <p class="tw-text-200 tw-font-light tw-text-teal-700" i18n="@@personalizedPlanIntro">Let's go through your personalized plan</p>
      </div>
    </div>
  }
  <div [class.tw-p-4]="showArrowUI()" [class.tw-px-4]="!showArrowUI()" [class.tw-pb-4]="!showArrowUI()">
    <div class="tw-w-full tw-bg-gray-100 tw-py-4 tw-px-3 tw-rounded-2.5 tw-mb-4">
      <!-- Repair -->
      @if (showRepairSection()) {
        <div class="tw-w-full tw-mb-3 tw-flex tw-items-start tw-gap-2 tw-font-lexend">
          <div class="tw-pt-0.5">
            <svg class="tw-w-4 tw-h-4" width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 12L10 18L20 6" stroke="black" stroke-width="3" stroke-linecap="butt" stroke-linejoin="miter"/>
            </svg>
          </div>
          <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.5">
            <h1 class="tw-text-300 tw-font-bold" i18n="@@targetConcern">Target your {{ displayConcern() }}</h1>
            @if (isHair()) {
              <p class="tw-text-200 tw-font-light tw-leading-[17px] tw-mb-0.5" i18n="@@hairRepairClinicallyProven">Products with clinically proven ingredients like</p>
            } @else {
              <p class="tw-text-200 tw-font-light tw-leading-[17px] tw-mb-0.5" i18n="@@repairCreamWithIngredients">Repair cream with ingredients like</p>
            }
            <div class="tw-w-fit tw-flex tw-flex-wrap tw-items-center tw-justify-start tw-gap-1">
              @for (item of repairItems(); track item.id) {
                <div class="tw-min-w-fit tw-text-nowrap tw-px-2 tw-py-1 tw-bg-white tw-shadow-z1 tw-rounded-[5px] tw-text-200 tw-text-teal-700 tw-font-body tw-font-normal tw-flex tw-items-center tw-gap-1">
                  @if (item.imageUrl) {
                    <img [src]="item.imageUrl" class="tw-w-4 tw-h-4 tw-object-contain" alt="" />
                  }
                  {{ item.text }}
                </div>
              }
            </div>
          </div>
        </div>
      }
      <!-- Routine -->
      <div class="tw-w-full tw-mb-3 tw-flex tw-items-start tw-gap-2 tw-font-lexend">
        <div class="tw-pt-0.5">
          <svg class="tw-w-4 tw-h-4" width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 12L10 18L20 6" stroke="black" stroke-width="3" stroke-linecap="butt" stroke-linejoin="miter"/>
          </svg>
        </div>
        <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.5">
          @if (isHair()) {
            <h1 class="tw-text-300 tw-font-bold" i18n="@@hairCareRoutine">Hair care routine</h1>
          } @else {
            <h1 class="tw-text-300 tw-font-bold" i18n="@@dailySkincareRoutine">Daily skincare routine</h1>
          }
          <ul class="tw-text-200 tw-font-light tw-leading-[17px] tw-list-disc tw-pl-5">
            @if (isHair()) {
              @for (item of hairRoutineItems(); track item.id) {
                <li [innerHTML]="item.text"></li>
              }
            } @else {
              @for (item of routineItems(); track item.id) {
                <li>{{ item.text }}</li>
              }
            }
            @if (!isHair()) {
              <li i18n="@@sunscreenWithAdvancedUVFilters">Sunscreen with advanced UV filters</li>
              <li i18n="@@moisturiserToRebuildSkinBarrier">Moisturiser to rebuild your skin barrier</li>
            }
          </ul>
        </div>
      </div>
      <!-- Supplements -->
      @if (supplementItems().length) {
        <div class="tw-w-full tw-flex tw-items-start tw-gap-2 tw-font-lexend">
          <div class="tw-pt-0.5">
            <svg class="tw-w-4 tw-h-4" width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 12L10 18L20 6" stroke="black" stroke-width="3" stroke-linecap="butt" stroke-linejoin="miter"/>
            </svg>
          </div>
          <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.5">
            @if (isHair()) {
              <h1 class="tw-text-300 tw-font-bold" i18n="@@supplementsAndOrals">Supplements & Orals</h1>
            } @else if (showFaceMaskHeader()) {
              <h1 class="tw-text-300 tw-font-bold" i18n="@@faceMasks">Face Masks (Optional)</h1>
            } @else if (showSebumHeader()) {
              <h1 class="tw-text-300 tw-font-bold" i18n="@@sebumControlGel">Sebum Control Gel (Optional)</h1>
            } @else {
              <h1 class="tw-text-300 tw-font-bold" i18n="@@supplementsOptional">Supplements (Optional)</h1>
            }
            @if (isHair()) {
              <ul class="tw-text-200 tw-font-light tw-leading-[17px] tw-list-disc tw-pl-5">
                @for (item of supplementItems(); track item.id) {
                  <li>{{ item.text }}</li>
                }
              </ul>
            } @else {
              <p class="tw-text-200 tw-font-light tw-leading-[17px]">{{ supplementItems()[0]?.text }}</p>
            }
          </div>
        </div>
      }
    </div>
    <div class="tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-2.5">
      <svg class="tw-w-[18px] tw-h-[18px] tw-ml-2" width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="5" width="18" height="16" rx="2" stroke="#6B6B6B" stroke-width="2"/>
        <line x1="3" y1="10.5" x2="21" y2="10.5" stroke="#6B6B6B" stroke-width="2"/>
        <line x1="8" y1="3" x2="8" y2="7" stroke="#6B6B6B" stroke-width="2" stroke-linecap="round"/>
        <line x1="16" y1="3" x2="16" y2="7" stroke="#6B6B6B" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-font-lexend">
        <h1 class="tw-text-300 tw-font-extrabold tw-text-teal-500 tw-leading-4" i18n="@@doctorCheckupAfterTwoWeeks">Doctor Checkup: <span class="tw-font-normal">After 2 weeks</span></h1>
        @if (isHair()) {
          <p class="tw-text-200 tw-font-light tw-text-teal-700" i18n="@@hairImprovementCheck">We will check your hair improvement.</p>
        } @else {
          <p class="tw-text-200 tw-font-light tw-text-teal-700" i18n="@@skinImprovementCheck">We will check your skin improvement.</p>
        }
      </div>
    </div>
  </div>
</div>
